import script from "./PlatformAdminDashboardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatformAdminDashboardView.vue?vue&type=script&setup=true&lang=ts"

import "./PlatformAdminDashboardView.vue?vue&type=style&index=0&id=59e27b90&lang=scss"

const __exports__ = script;

export default __exports__